module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Coltan, Congo’s Curse")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch004#acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#disclaimer"
    }
  }, [_vm._v("Disclaimer")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch006#april-07-1994"
    }
  }, [_vm._v("April 07, 1994")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch007#prologue"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch008#chapter-1-natural-resources"
    }
  }, [_vm._v("Chapter 1: Natural Resources")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch009#chapter-2-old-friends"
    }
  }, [_vm._v("Chapter 2: Old Friends")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#chapter-3-memories",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Memories")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch011#chapter-4-shopping",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Shopping")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch012#chapter-5-going-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Going Back")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch013#chapter-6-perilous-moves",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Perilous Moves")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch014#chapter-7-the-shit-hits-the-fan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Shit Hits the Fan")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch015#chapter-8-the-real-game-begins",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: The Real Game Begins")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch016#chapter-9-check.-the-king-needs-to-make-a-move",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Check. The King Needs to Make a Move")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch017#chapter-10-do-horses-jump",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Do Horses Jump?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch018#chapter-11-check-again.-the-king-stumbles",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Check Again. The King Stumbles")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch019#chapter-12-anxious-moves-of-a-king",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Anxious Moves of a King")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch020#chapter-13-moves-of-a-queen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Moves of a Queen")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch021#chapter-14-a-last-pawn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: A Last Pawn")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch022#chapter-15-reshuffling-the-game",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Reshuffling the Game")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch023#chapter-16-explanations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Explanations")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch024#chapter-17-endgame",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Endgame?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch025#chapter-18-davos",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Davos")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch026#chapter-19-home-at-last",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Home, at Last")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch027#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb74dd3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/nav.vue
// module id = 60
// module chunks = 0